import { Button, Dropdown, Input, Menu, Modal, message } from "antd";
import { CSSProperties, useState } from "react";
import MainView from "../MainView";
import SystemView from "../SystemView";
import UserImg from '../../res/users.png'
import { URL_logout, URL_updatePwd, requestUrl } from "../Utils/UrlUtils";
import { useNavigate } from "react-router-dom";
export default () => {
  // state = {
  //   current: 'fileList',
  //   mainView:<MainView/>,
  //   systemView:undefined,
  // };
  const navigate = useNavigate()
  const [messageApi, contextHolder] = message.useMessage();
  const [systemView, setSystemView] = useState<any>()
  const [mainView, setMainView] = useState<any>(<MainView />)
  const [current, setCurrent] = useState<string>('fileList')

  const [openUserMsg, setOpenUserMsg] = useState<boolean>(false)
  const [openUpdatePwd, setOpenUpdatePwd] = useState<boolean>(false)

  const [oldPwd, setOldPwd] = useState<string>()
  const [newPwd, setNewPwd] = useState<string>()
  const [newPwd2, setNewPwd2] = useState<string>()

  const [updataPwdLoading, setUpdataPwdLoading] = useState<boolean>(false)

  const styleModel: CSSProperties = {
    padding: 10,
    paddingTop: 5,
    paddingBottom: 5,
    display: 'flex',
    justifyItems: 'center',
    alignItems: 'center'
  }
  const handleClick = (e: any) => {
    let key = e.key;
    if (key == 'system') {
      if (!systemView) setSystemView(<SystemView />)
    }
    // this.setState({current: e.key});
    setCurrent(e.key)
  }
  /**
   * 修改密码方法
   */
  const updatePwd = () => {
    if (!oldPwd || !newPwd || !newPwd2) return
    if (newPwd != newPwd2) {
      messageApi.open({ type: 'warning', content: '两次密码不一致' })
      return
    }
    let body = {
      "beforePwd": oldPwd,
      "pwd": newPwd
    }
    setUpdataPwdLoading(true)
    requestUrl({
      url: URL_updatePwd,
      method: 'POST',
      body: JSON.stringify(body),
      success: function (data) {
        setOpenUpdatePwd(false)
        messageApi.open({ type: 'success', content: '修改成功' })
      },
      fail: function (msg) {
        messageApi.open({ type: 'error', content: '修改失败  ' + msg })
      },
      finally: function () {
        setUpdataPwdLoading(false)
      }
    })
  }

  /**
   * 退出登录
   */
  const loginout = () => {
    requestUrl({
      url: URL_logout,
      method: 'POST',
      success: function (data) {
        messageApi.open({ type: 'success', content: '退出成功' })
        sessionStorage.removeItem('token')
        sessionStorage.removeItem('userName')
        sessionStorage.removeItem('phone')
        navigate('/')
      },
      fail: function (msg) {
        messageApi.open({ type: 'error', content: '退出失败  ' + msg })
      },
      finally: function () {

      }
    })
  }

  const menu = () => {
    return <Menu
      onClick={(e: any) => {
        e.domEvent.stopPropagation()
      }}>
      <Menu.Item onClick={() => setOpenUserMsg(true)}>用户信息</Menu.Item>
      <Menu.Item onClick={() => setOpenUpdatePwd(true)}>修改密码</Menu.Item>
      <Menu.Item onClick={() => loginout()}>退出登录</Menu.Item>
    </Menu>
  }
  var userName = sessionStorage.getItem('userName')
  // render() {
  return (
    <>
      {contextHolder}
      <div style={{ width: '100vw', height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ width: '100%', display: 'flex' }}>
          <Menu
            style={{ flex: 1 }}
            onClick={handleClick}
            selectedKeys={[current]}
            theme="dark"
            mode="horizontal">
            <div style={{ fontSize: '16px', textAlign: 'center', minWidth: 256, color: 'white', fontWeight: 'bold' }}>大连公路建设部行业文件汇编</div>
            <Menu.Item key="fileList" >
              <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>文件列表</div>
            </Menu.Item>
            <Menu.Item key="system">
              <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>系统管理</div>
            </Menu.Item>
          </Menu>
          <Dropdown overlay={menu()} placement="bottomLeft">
            <div style={{
              backgroundColor: '#001529', color: 'white', paddingRight: '30px', paddingLeft: '30px', alignItems: 'center',
              justifyContent: 'center', justifyItems: 'center', display: 'flex'
            }}>
              <img src={UserImg}></img>
              <div style={{ marginLeft: '10px' }}>{userName}</div>
            </div>
          </Dropdown>
        </div>
        <div style={{ flex: '1', display: current == 'fileList' ? 'block' : 'none' }}>
          {mainView ? mainView : <></>}
        </div>
        <div style={{ flex: '1', display: current == 'system' ? 'block' : 'none' }}>
          {systemView ? systemView : <></>}
        </div>
      </div>

      <Modal
        open={openUserMsg}
        // maskClosable={false}
        destroyOnClose
        title={"用户信息"}
        afterClose={() => { }}
        onCancel={() => setOpenUserMsg(false)}
        footer={<Button type="primary" onClick={() => setOpenUserMsg(false)}>{'确定'}</Button>}
      >
        <div style={{ marginTop: '10px', marginLeft: '15px' }}>用&ensp;户&ensp;名：{userName}</div>
        <div style={{ marginTop: '10px', marginLeft: '15px' }}>电话号码：{sessionStorage.getItem('phone')}</div>
        <div style={{ marginTop: '10px', marginLeft: '15px' }}>单&emsp;&emsp;位：{sessionStorage.getItem('unit') == 'null' ? '' : sessionStorage.getItem('unit')}</div>
      </Modal>
      <Modal
        open={openUpdatePwd}
        maskClosable={false}
        destroyOnClose
        title={"修改密码"}
        afterClose={() => {
          setOldPwd(undefined)
          setNewPwd(undefined)
          setNewPwd2(undefined)
        }}
        onCancel={() => setOpenUpdatePwd(false)}
        footer={
          <Button
            type="primary"
            loading={updataPwdLoading}
            onClick={() => updatePwd()}>
            {updataPwdLoading ? '提交中...' : '确定'}
          </Button>}
      >
        <div style={styleModel}>
          旧&ensp;密&ensp;码：<Input style={{ flex: 1 }} value={oldPwd} onChange={(e) => setOldPwd(e.target.value)} />
        </div>
        <div style={styleModel}>
          新&ensp;密&ensp;码：<Input style={{ flex: 1 }} value={newPwd} onChange={(e) => setNewPwd(e.target.value)} />
        </div>
        <div style={styleModel}>
          重复密码：<Input style={{ flex: 1 }} value={newPwd2} onChange={(e) => setNewPwd2(e.target.value)} />
        </div>
      </Modal>
    </>
  );
  // }
}